import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { BannerEmailRenderer } from "./email";
import { BannerBlockProps } from "./types";

export default function BannerWeb(props: BannerBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <BannerEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
